import { ColumnInfo } from "../../../../models/column-info";
import { alignment } from "../../models/alignment.enum";
import { Part, RefinedParts } from "../../models/part";
import { partTypeEnum } from "./part-type.enum";
import { crownType } from "./crown-type.enum";
import { headType } from "./head-type.enum";
import { defaultHeadLeft, defaultHeadRight } from "./head-types.model";
import { middleType } from "./middle-type.enum";
import { plinthType } from "./plinth-type.enum";
import { facadeType } from "./facade-type.enum";
import { Column, UnitAmount } from "../../models/column";
import { columnType } from "./column-type.enum";
import { segmentType } from "./segment-type";
import { subtypeEnum, variantEnum } from "./column-definition";
import { unitBaseTypeEnum } from "../../../../unit-base-type-enum";
import { UnitWish } from "../../../../models/unit-wish-list";
import { InitialProps } from "../../Common/BuildingInitialPropertiesDialog/init-props";

export type HybridColumn = Column<columnType | headType, segmentType, subtypeEnum, variantEnum>;
export type HybridPart = Part<HybridColumn, partTypeEnum>;
export type HybridRefinedParts = RefinedParts<HybridColumn, partTypeEnum>;

const galleryWishList: UnitWish[] = [
    // {
    //     type: unitBaseTypeEnum.G_XS,
    //     uiName: 'XS',
    //     percentage: 20,
    // },
    {
        type: unitBaseTypeEnum.G_S,
        uiName: 'S',
        percentage: 25,
    },
    {
        type: unitBaseTypeEnum.G_M,
        uiName: 'M',
        percentage: 25,
    },
    {
        type: unitBaseTypeEnum.G_L,
        uiName: 'L',
        percentage: 25,
    },
    {
        type: unitBaseTypeEnum.G_XL,
        uiName: 'XL',
        percentage: 25,
    },
]

export const defaultUnitWishList: UnitWish[] =
    [
        ...galleryWishList,
        {
            type: unitBaseTypeEnum.H_S,
            uiName: 'S',
            percentage: 30,
        },
        {
            type: unitBaseTypeEnum.H_M,
            uiName: 'M',
            percentage: 40,
        },
        {
            type: unitBaseTypeEnum.H_L,
            uiName: 'L',
            percentage: 30,
        }
    ]


export const defaultUnitWishListGallery: UnitWish[] =
    [
        ...galleryWishList,
    ]

export type PropsHybrid = {
    buildingWidth: number;
    buildingLength: number;
    buildingHeight: number;
    plinthType: plinthType;
    middleType: middleType;
    crownType: crownType;
    plinthFloors: number;
    customPlinthHeight: number;
    customPlinthWidth: number;
    crownFloors: number;
    moosPlazaType: columnType;
    moosPlazaAlignment: alignment;
    moosPlazaBays: number;
    headLeftType: headType;
    headRightType: headType;
    facade: facadeType;
    unitWishList: UnitWish[];
    totalPercentageG: number;
    totalPercentageH: number;
    amount_G_M_Columns: number;
    amount_G_S1S2_Columns: number;
    amount_G_L1L2_Columns: number;
    amount_G_XL_Columns: number;
    parts: HybridPart[];
    info: ColumnInfo;
    totalAmountOfAllUnits: UnitAmount[];
    partsRefined: HybridRefinedParts[];
}


export const getDefaultPropsHybrid = (initProps: InitialProps): PropsHybrid => {
    let unitWishList = initProps.unitWishList.length > 0 ? initProps.unitWishList : defaultUnitWishList;
    return {
        buildingWidth: 15,
        buildingLength: 68,
        buildingHeight: 15.625,
        plinthType: plinthType.H,
        middleType: middleType.G,
        crownType: crownType.H,
        plinthFloors: 2,
        customPlinthHeight: 0,
        customPlinthWidth: 0,
        crownFloors: 2,
        facade: facadeType.wood,
        moosPlazaType: columnType.V_P3,
        moosPlazaAlignment: alignment.left,
        moosPlazaBays: 3,
        headLeftType: defaultHeadLeft,
        headRightType: defaultHeadRight,
        unitWishList,
        totalPercentageG: 100,
        totalPercentageH: 100,
        amount_G_M_Columns: 0,
        amount_G_S1S2_Columns: 0,
        amount_G_L1L2_Columns: 0,
        amount_G_XL_Columns: 0,
        parts: [],
        partsRefined: [],
        info: {
            totalGFA: 0,
            totalUFA: 0,
        },
        totalAmountOfAllUnits: [],
    }
}

export const getDefaultPropsSingleLoadedCorridor = (initProps: InitialProps): PropsHybrid => {
    let unitWishList = initProps.unitWishList.length > 0 ? initProps.unitWishList : defaultUnitWishListGallery;
    return {
        buildingWidth: 15,
        buildingLength: 75,
        buildingHeight: 15.625,
        plinthType: plinthType.G,
        middleType: middleType.G,
        crownType: crownType.G,
        plinthFloors: 2,
        customPlinthHeight: 0,
        customPlinthWidth: 0,
        crownFloors: 1,
        facade: facadeType.wood,
        moosPlazaType: columnType.V_P3,
        moosPlazaAlignment: alignment.left,
        moosPlazaBays: 3,
        headLeftType: defaultHeadLeft,
        headRightType: defaultHeadRight,
        unitWishList,
        totalPercentageG: 100,
        totalPercentageH: 100,
        amount_G_M_Columns: 0,
        amount_G_S1S2_Columns: 0,
        amount_G_L1L2_Columns: 0,
        amount_G_XL_Columns: 0,
        parts: [],
        partsRefined: [],
        info: {
            totalGFA: 0,
            totalUFA: 0,
        },
        totalAmountOfAllUnits: [],
    }
}